/**
 * Created by uri.khaimov on 23/11/2017.
 */
import PropTypes from 'prop-types';

import React from 'react';
import Style from './toolTip.scss';
import styled from 'styled-components';

const StyledStrip = styled.div`
            background-color: ${props => props.theme.borderColor};
            
            p {
                color:${props => props.theme.pageBackground};
            }     
`;

const StyledToolTip = styled.div`
            background-color: ${props => props.theme.hoverColorLighten};
            border: 1px solid  ${props => props.theme.borderColor};
            
`;

class ToolTip extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hover:false

        };
        this.mouseOver = this.mouseOver.bind(this);
        this.mouseOut = this.mouseOut.bind(this);
        this.onClick = this.onClick.bind(this);

    }

    onClick(event) {
        event.preventDefault();
        this.mouseOver();

    }
    mouseOver() {
        this.setState({hover: true});
    }

    mouseOut() {
        this.setState({hover: false});
    }

    render() {
        let toolTip = null;
        let listBadgesData = this.props.listBadgesData;
        let listColumnsData = this.props.listColumnsData;
        let listData = listBadgesData.concat(listColumnsData);
        let ariaLabelledBy = listData.map(function(data){
            if(!data)return;
            return `${data.keyCaption} ${data.valueCaption}`;
        }).join(', ');


        let badges = listBadgesData.map((badge)=> {
            if(badge) {
                return (
                    <li id={badge.key} key ={badge.key}>
                        {badge.keyCaption}: {badge.valueCaption}
                    </li>
                )
            }

        });

        let columnsContainer =  listColumnsData.map((column)=> {
            if(column) {
                return (
                    <li id={column.key} key ={column.key}>
                        {column.keyCaption}: {column.valueCaption}
                    </li>
                )
            }

        });

        if(this.state.hover) {
            toolTip = <StyledToolTip className={Style.wrapper}>
                <ul>
                    {badges}
                </ul>
                <ul>
                    {columnsContainer}
                </ul>
            </StyledToolTip>
        }


        return (
            <StyledStrip aria-label={ariaLabelledBy} tabIndex='0' className={Style.strip} onClick = {this.onClick} onMouseOver={this.mouseOver} onMouseLeave={this.mouseOut}>
                <p>...</p>
                {toolTip}
            </StyledStrip>
        );
    }
}

ToolTip.propTypes = {
    listBadgesData: PropTypes.array.isRequired,
    listColumnsData: PropTypes.array.isRequired
};

export default ToolTip;


// WEBPACK FOOTER //
// ./components/Scoreboard/toolTip.js